const CITY_CENTERS = [
  { name: 'Ahmedabad', lat: 23.0225, lng: 72.5714 },
  { name: 'Alwar',     lat: 27.5530, lng: 76.6346 },
  { name: 'Bengaluru', lat: 12.9716, lng: 77.5946 },
  { name: 'Chennai',   lat: 13.0827, lng: 80.2707 },
  { name: 'Delhi',     lat: 28.7041, lng: 77.1025 },
  { name: 'Faridabad', lat: 28.4089, lng: 77.3178 },
  { name: 'Gurugram',  lat: 28.4595, lng: 77.0266 },
  { name: 'Hyderabad', lat: 17.3850, lng: 78.4867 },
  { name: 'Jaipur',    lat: 26.9124, lng: 75.7873 },
  { name: 'Kanpur',    lat: 26.4499, lng: 80.3319 },
  { name: 'Lucknow',   lat: 26.8467, lng: 80.9462 },
  { name: 'Mumbai',    lat: 19.0760, lng: 72.8777 },
  { name: 'Noida',     lat: 28.5355, lng: 77.3910 },
  { name: 'Pune',      lat: 18.5204, lng: 73.8567 },
  { name: 'Surat',     lat: 21.1702, lng: 72.8311 },
]

const RADIUS_KM = 40

function haversineKm(lat1, lon1, lat2, lon2) {
  const R = 6371
  const toRad = deg => deg * Math.PI / 180
  const dLat = toRad(lat2 - lat1)
  const dLon = toRad(lon2 - lon1)
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

export function resolveCity(lat, lng) {
  if (lat == null || lng == null) return 'Others'
  let nearest = null
  let minDist = Infinity
  for (const city of CITY_CENTERS) {
    const dist = haversineKm(lat, lng, city.lat, city.lng)
    if (dist < minDist) { minDist = dist; nearest = city }
  }
  return minDist <= RADIUS_KM ? nearest.name : 'Others'
}
